var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.694 18.7073C16.085 18.316 16.085 17.6826 15.694 17.2913L10.414 12.0075L15.71 6.70772C16.1 6.31744 16.1 5.68299 15.71 5.29271C15.319 4.90243 14.686 4.90243 14.296 5.29271L8.293 11.3H8.292C8.097 11.4951 8 11.7513 8 12.0085C8 12.2647 8.097 12.5199 8.292 12.716H8.293L14.28 18.7073C14.67 19.0976 15.303 19.0976 15.694 18.7073",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron_left.ce1fa7f1b70d3b1f8fd3301070a7d6f6.svg";